import { TData } from 'entries/common/widgets/context';

export const hasProjectConfigurationData = (data: TData | null) =>
  Boolean(data?.projectConfigurationParameters) && Boolean(data?.surfaces);
